import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import angel from "../assets/test1.jpg";
import "../styles/Angel.scss"

function Angel3() {
  const [effect, setEffect] = useState(null);
  const canvasRef = useRef(null);

  const image1 = useMemo(() => {
    const img = new Image();
    img.src = angel;
    return img;
  }, []);

  const applyEffect = useCallback(
    (cellSize) => {
      if (effect) {
        effect.draw(cellSize);
      }
    },
    [effect]
  );

  useEffect(() => {
    const canvas = canvasRef.current;

    const ctx = canvas.getContext("2d", { alpha: false });

    function resizeImage(image, maxWidth, maxHeight) {
      const canvas = document.createElement("canvas");
      const ratio = Math.min(maxWidth / image.width, maxHeight / image.height);
      canvas.width = image.width * ratio;
      canvas.height = image.height * ratio;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL("image/jpeg");
    }

    const resizedImageSrc = resizeImage(image1, 750, 750);
    const resizedImage = new Image();
    resizedImage.src = resizedImageSrc;

    class Cell {
      constructor(x, y, symbol, color) {
        this.x = x;
        this.y = y;
        this.symbol = symbol;
        this.color = color;
      }
      draw(ctx) {
        // next 2 lines are optional if u want a lighter image:
        ctx.fillStyle = "white";
        ctx.fillText(this.symbol, this.x + 0.5, this.y + 0.5);
        ctx.fillStyle = this.color;
        ctx.fillText(this.symbol, this.x, this.y);
      }
    }

    class AsciiEffect {
      #imageCellArray = [];
      #pixels = [];
      #ctx;
      #width;
      #height;
      constructor(ctx, width, height) {
        this.#ctx = ctx;
        this.#width = width;
        this.#height = height;
        this.#ctx.drawImage(image1, 0, 0, this.#width, this.#height);
        this.#pixels = this.#ctx.getImageData(0, 0, this.#width, this.#height);
      }
      #convertToSymbol(g) {
        if (g > 250) return "@";
        else if (g > 240) return "*";
        else if (g > 220) return "+";
        else if (g > 200) return "#";
        else if (g > 180) return "&";
        else if (g > 160) return "%";
        else if (g > 140) return "_";
        else if (g > 120) return ":";
        else if (g > 100) return "$";
        else if (g > 80) return "/";
        else if (g > 60) return "-";
        else if (g > 40) return "X";
        else if (g > 20) return "W";
        else return "";
      }
      #scanImage(cellSize) {
        this.#imageCellArray = [];
        for (let y = 0; y < this.#pixels.height; y += cellSize) {
          for (let x = 0; x < this.#pixels.width; x += cellSize) {
            const posX = x * 4;
            const posY = y * 4;
            const pos = posY * this.#pixels.width + posX;

            if (this.#pixels.data[pos + 3] > 128) {
              const red = this.#pixels.data[pos];
              const green = this.#pixels.data[pos + 1];
              const blue = this.#pixels.data[pos + 2];
              const total = red + green + blue;
              const averageColorValue = total / 3;
              const color = "rgb(" + red + "," + green + "," + blue + ")";
              const symbol = this.#convertToSymbol(averageColorValue);
              if (total > 200)
                this.#imageCellArray.push(new Cell(x, y, symbol, color));
            }
          }
        }
      }
      #drawAscii() {
        this.#ctx.clearRect(0, 0, this.#width, this.#height);
        for (let i = 0; i < this.#imageCellArray.length; i++) {
          this.#imageCellArray[i].draw(this.#ctx);
        }
      }
      draw(cellSize) {
        this.#scanImage(cellSize);
        this.#drawAscii();
      }
    }

    function initializeEffect() {
      if (!effect && resizedImage.complete) {
      canvas.width = resizedImage.width;
      canvas.height = resizedImage.height;
      const newEffect = new AsciiEffect(ctx, resizedImage.width, resizedImage.height);
      setEffect(newEffect);
      newEffect.draw(5);
    }
  }

  resizedImage.addEventListener("load", initializeEffect);
  image1.addEventListener("load", () => {
    resizedImage.src = resizeImage(image1, 750, 750);
  });
  initializeEffect();


    const intervalId = setInterval(() => {
      const randomCellSize = Math.floor(Math.random() * 20) + 1;
      applyEffect(randomCellSize);
      setTimeout(() => applyEffect(5), 500); 
    }, 5000); 

    return () => {
      clearInterval(intervalId);
      resizedImage.removeEventListener("load", initializeEffect);
      image1.removeEventListener("load", () => {
        resizedImage.src = resizeImage(image1, 750, 750);
      });
    };
  }, [applyEffect, effect, image1]);

  return (
    <div className="angel3">
      <canvas ref={canvasRef} className="angel-canvas" width="1500" height="1500" id="canvas1"></canvas>
    </div>
  );
}

export default Angel3;